var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "display" },
    [
      _vm.loadingMessages
        ? _c(
            "div",
            { staticClass: "text-xs-center targetFirst_loading" },
            [
              _c("v-progress-circular", {
                staticClass: "primary--text",
                attrs: { indeterminate: "", size: 100, width: 1 }
              })
            ],
            1
          )
        : _c(
            "div",
            [
              _vm.userRights == 1
                ? _c(
                    "v-layout",
                    {
                      staticClass: "layoutTraficVisiteurs bigChat",
                      attrs: { row: "", wrap: "" }
                    },
                    [
                      (!_vm.dataVisiteurComputed.visiteurID &&
                        _vm.$vuetify.breakpoint.xsOnly) ||
                      !_vm.$vuetify.breakpoint.xsOnly
                        ? _c(
                            "v-flex",
                            {
                              staticClass: "traficListVisiteurs fill-height",
                              class: { sm3: _vm.dataMessageSelected },
                              attrs: { xs12: "" }
                            },
                            [
                              _c(
                                "v-card",
                                { staticClass: "cardTraficVisiteurs" },
                                [
                                  _c(
                                    "v-card-title",
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: { "offset-y": "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        {
                                                          staticClass:
                                                            "white--text",
                                                          attrs: {
                                                            loading:
                                                              _vm.loadingMessages,
                                                            disabled:
                                                              _vm.loadingMessages,
                                                            color: "primary"
                                                          }
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        !_vm.dataMessageSelected &&
                                                        !_vm.$vuetify.breakpoint
                                                          .xsOnly
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f("cap")(
                                                                    _vm.$t(
                                                                      "ranking"
                                                                    )
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.typeClassement ==
                                                        "new"
                                                          ? _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  right:
                                                                    !_vm.dataMessageSelected &&
                                                                    !_vm
                                                                      .$vuetify
                                                                      .breakpoint
                                                                      .xsOnly,
                                                                  dark: ""
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "flip_to_front"
                                                                )
                                                              ]
                                                            )
                                                          : _vm.typeClassement ==
                                                            "old"
                                                          ? _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  right:
                                                                    !_vm.dataMessageSelected &&
                                                                    !_vm
                                                                      .$vuetify
                                                                      .breakpoint
                                                                      .xsOnly,
                                                                  dark: ""
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "flip_to_back"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            3019517186
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "v-list",
                                            _vm._l(
                                              _vm.itemsClassementPeon,
                                              function(item, index) {
                                                return _c(
                                                  "v-list-tile",
                                                  {
                                                    key: index,
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.getMessagesAgents(
                                                          _vm.listeAgentId,
                                                          item.type
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile-title",
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              left:
                                                                !_vm.dataMessageSelected &&
                                                                !_vm.$vuetify
                                                                  .breakpoint
                                                                  .xsOnly
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(item.icone)
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        !_vm.dataMessageSelected &&
                                                        !_vm.$vuetify.breakpoint
                                                          .xsOnly
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.title
                                                                )
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c("v-subheader", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$tc(
                                              "messageAttente",
                                              _vm.maListeMessagesAttente.length,
                                              {
                                                count:
                                                  _vm.maListeMessagesAttente
                                                    .length
                                              }
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list",
                                        {
                                          staticClass: "listeTraficVisiteurs",
                                          attrs: { "two-line": "", dense: "" }
                                        },
                                        _vm._l(
                                          _vm.maListeMessagesAttente,
                                          function(messageAttente, i) {
                                            return _c(
                                              "div",
                                              {
                                                key: i,
                                                staticClass: "wz_wrapChips"
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  {
                                                    staticClass:
                                                      "visiteurFiltrer",
                                                    attrs: {
                                                      xs12: "",
                                                      sm12: ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile",
                                                      {
                                                        key:
                                                          messageAttente.status,
                                                        class: {
                                                          "light-blue lighten-4":
                                                            _vm
                                                              .messageAttenteSelected
                                                              .visiteurID ==
                                                            messageAttente.visiteurID
                                                        },
                                                        attrs: { ripple: "" },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.openMessageVisiteur(
                                                              _vm.myId,
                                                              messageAttente
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-tile-avatar",
                                                          [
                                                            messageAttente.network ==
                                                              "moon" ||
                                                            !messageAttente.network
                                                              ? _c(
                                                                  "wz-avatar",
                                                                  {
                                                                    staticClass:
                                                                      "pl-1",
                                                                    attrs: {
                                                                      username:
                                                                        "#" +
                                                                        messageAttente.visiteurID,
                                                                      size:
                                                                        "38px"
                                                                    }
                                                                  }
                                                                )
                                                              : messageAttente.network ==
                                                                "facebook"
                                                              ? _c(
                                                                  "wz-avatar",
                                                                  {
                                                                    staticClass:
                                                                      "pl-1",
                                                                    attrs: {
                                                                      src:
                                                                        messageAttente.profile_pic,
                                                                      username:
                                                                        messageAttente.visiteurName,
                                                                      size:
                                                                        "38px"
                                                                    }
                                                                  }
                                                                )
                                                              : messageAttente.network ==
                                                                "whatsapp"
                                                              ? _c(
                                                                  "wz-avatar",
                                                                  {
                                                                    staticClass:
                                                                      "pl-1",
                                                                    attrs: {
                                                                      src:
                                                                        messageAttente.profile_pic,
                                                                      username:
                                                                        messageAttente.visiteurName,
                                                                      size:
                                                                        "38px"
                                                                    }
                                                                  }
                                                                )
                                                              : !_vm.istypingVisiteur &&
                                                                messageAttente.message &&
                                                                messageAttente.visiteurID !=
                                                                  _vm.messageAttenteSelected
                                                              ? _c(
                                                                  "wz-avatar",
                                                                  {
                                                                    attrs: {
                                                                      username:
                                                                        "#" +
                                                                        messageAttente.visiteurID,
                                                                      size:
                                                                        "38px",
                                                                      lastMessage:
                                                                        ""
                                                                    }
                                                                  }
                                                                )
                                                              : _vm.istypingVisiteur
                                                              ? _c(
                                                                  "wz-avatar",
                                                                  {
                                                                    attrs: {
                                                                      isTyping:
                                                                        _vm.istypingVisiteur,
                                                                      username:
                                                                        "#" +
                                                                        messageAttente.visiteurID,
                                                                      size:
                                                                        "38px",
                                                                      chip: ""
                                                                    }
                                                                  }
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile-content",
                                                          [
                                                            _c(
                                                              "v-list-tile-title",
                                                              [
                                                                messageAttente.network ==
                                                                  "moon" ||
                                                                !messageAttente.network
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "wz_nameVisiteur"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                " +
                                                                            _vm._s(
                                                                              messageAttente.visiteurID
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "(" +
                                                                                _vm._s(
                                                                                  _vm.dateMessageFromNow(
                                                                                    messageAttente.timestamp
                                                                                  )
                                                                                ) +
                                                                                ")"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                messageAttente.network ==
                                                                "email"
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "wz_nameVisiteur"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                " +
                                                                            _vm._s(
                                                                              messageAttente.visiteurID
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "(" +
                                                                                _vm._s(
                                                                                  _vm.dateMessageFromNow(
                                                                                    messageAttente.timestamp
                                                                                  )
                                                                                ) +
                                                                                ")"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : messageAttente.network ==
                                                                    "facebook"
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "wz_nameVisiteur"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                " +
                                                                            _vm._s(
                                                                              messageAttente.visiteurName
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "(" +
                                                                                _vm._s(
                                                                                  _vm.dateMessageFromNow(
                                                                                    messageAttente.timestamp
                                                                                  )
                                                                                ) +
                                                                                ")"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : messageAttente.network ==
                                                                    "whatsapp"
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "wz_nameVisiteur"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                " +
                                                                            _vm._s(
                                                                              messageAttente.visiteurName
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "(" +
                                                                                _vm._s(
                                                                                  _vm.dateMessageFromNow(
                                                                                    messageAttente.timestamp
                                                                                  )
                                                                                ) +
                                                                                ")"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            messageAttente
                                                              .message.length
                                                              ? _c(
                                                                  "v-list-tile-sub-title",
                                                                  [
                                                                    messageAttente
                                                                      .message
                                                                      .length
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "wz_alertFiltre",
                                                                            attrs: {
                                                                              slot:
                                                                                "activator"
                                                                            },
                                                                            slot:
                                                                              "activator"
                                                                          },
                                                                          [
                                                                            messageAttente.network ==
                                                                              "moon" ||
                                                                            !messageAttente.network
                                                                              ? _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    staticClass:
                                                                                      "secondary--text text--lighten-1",
                                                                                    attrs: {
                                                                                      size:
                                                                                        "20"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "chat_bubble"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : messageAttente.network ==
                                                                                "email"
                                                                              ? _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    staticClass:
                                                                                      "blue-grey--text lighten-2",
                                                                                    attrs: {
                                                                                      size:
                                                                                        "20"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "email"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : messageAttente.network ==
                                                                                "facebook"
                                                                              ? _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    staticClass:
                                                                                      "",
                                                                                    attrs: {
                                                                                      size:
                                                                                        "20",
                                                                                      color:
                                                                                        "blue accent-4--text"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-facebook-messenger"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : messageAttente.network ==
                                                                                "whatsapp"
                                                                              ? _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    staticClass:
                                                                                      "",
                                                                                    attrs: {
                                                                                      size:
                                                                                        "20",
                                                                                      color:
                                                                                        "green accent-4--text"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-whatsapp"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "d-inline"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    messageAttente
                                                                                      .message[0]
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile-action",
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  slot:
                                                                    "activator",
                                                                  flat: "",
                                                                  icon: "",
                                                                  color:
                                                                    "accent"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.suppMessage(
                                                                      {
                                                                        messageId:
                                                                          messageAttente.messageId,
                                                                        agentId:
                                                                          messageAttente.agentId,
                                                                        visiteurId:
                                                                          messageAttente.visiteurID,
                                                                        message:
                                                                          messageAttente.message,
                                                                        timestamp:
                                                                          messageAttente.timestamp
                                                                      }
                                                                    )
                                                                  }
                                                                },
                                                                nativeOn: {
                                                                  mouseover: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.overMenu = true
                                                                  },
                                                                  mouseleave: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.overMenu = false
                                                                  }
                                                                },
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      large: "",
                                                                      color:
                                                                        "grey lighten-1"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "close"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-divider", {
                                                      attrs: { inset: "" }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dataMessageSelected
                        ? _c(
                            "v-flex",
                            {
                              staticClass: "traficInfosVisiteur fill-height",
                              attrs: { xs12: "", sm9: "" }
                            },
                            [
                              _vm.loadingHistoChat
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "wz_loadingChat text-xs-center"
                                    },
                                    [
                                      _c("v-progress-circular", {
                                        staticClass: "primary--text",
                                        attrs: {
                                          size: 70,
                                          width: 1,
                                          indeterminate: ""
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _c("wz-view-chat", {
                                    attrs: {
                                      datasViewPupitre:
                                        _vm.dataVisiteurComputed,
                                      timestampMessageSelected:
                                        _vm.dataVisiteurComputed,
                                      placesPupitre: 1
                                    },
                                    on: {
                                      activeCobrowsing: function($event) {
                                        return _vm.openCobrowsing(0)
                                      },
                                      stopCobrowsing: function($event) {
                                        return _vm.closeCobrowsing(0)
                                      },
                                      MAJHistoChat: _vm.MAJHistoChat
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.focusView({
                                          view: 1,
                                          visiteurID:
                                            _vm.messageAttenteSelected
                                              .visiteurID
                                        })
                                      }
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _c(
                    "v-layout",
                    {
                      staticClass: "layoutTraficVisiteurs bigChat",
                      attrs: { row: "", wrap: "" }
                    },
                    [
                      (_vm.typeClassement == "agent" &&
                        !_vm.dataVisiteurComputed.visiteurID &&
                        _vm.$vuetify.breakpoint.xsOnly) ||
                      (_vm.typeClassement == "agent" &&
                        !_vm.$vuetify.breakpoint.xsOnly)
                        ? _c(
                            "v-flex",
                            {
                              directives: [{ name: "bar", rawName: "v-bar" }],
                              staticClass: "traficListVisiteurs fill-height vb",
                              class: {
                                sm3: _vm.dataMessageSelected,
                                listeAgentsOverflow: _vm.dataMessageSelected
                              },
                              attrs: { xs12: "" }
                            },
                            [
                              _c(
                                "v-card",
                                { staticClass: "cardTraficVisiteurs" },
                                [
                                  _c(
                                    "v-card-title",
                                    {},
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: { "offset-y": "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        {
                                                          staticClass:
                                                            "white--text",
                                                          attrs: {
                                                            loading:
                                                              _vm.loadingMessages,
                                                            disabled:
                                                              _vm.loadingMessages,
                                                            color: "primary"
                                                          }
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        !_vm.dataMessageSelected &&
                                                        !_vm.$vuetify.breakpoint
                                                          .xsOnly
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f("cap")(
                                                                    _vm.$t(
                                                                      "ranking"
                                                                    )
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              right:
                                                                !_vm.dataMessageSelected &&
                                                                !_vm.$vuetify
                                                                  .breakpoint
                                                                  .xsOnly,
                                                              dark: ""
                                                            }
                                                          },
                                                          [_vm._v("groups")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            2106414835
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "v-list",
                                            _vm._l(
                                              _vm.itemsClassement,
                                              function(item, index) {
                                                return _c(
                                                  "v-list-tile",
                                                  {
                                                    key: index,
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.getAllMessagesAttente(
                                                          _vm.listeAgentId,
                                                          item.type
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile-title",
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              left:
                                                                !_vm.dataMessageSelected &&
                                                                !_vm.$vuetify
                                                                  .breakpoint
                                                                  .xsOnly
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(item.icone)
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        !_vm.dataMessageSelected &&
                                                        !_vm.$vuetify.breakpoint
                                                          .xsOnly
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.title
                                                                )
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c("v-subheader", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$tc(
                                              "agents",
                                              _vm.agents.length,
                                              { count: _vm.agents.length }
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-expansion-panel",
                                        { attrs: { focusable: "" } },
                                        _vm._l(_vm.agents, function(agent, i) {
                                          return _c(
                                            "v-expansion-panel-content",
                                            { key: i },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "listeAgentsManagement",
                                                  attrs: { slot: "header" },
                                                  slot: "header"
                                                },
                                                [
                                                  _c("wz-avatar", {
                                                    attrs: {
                                                      username: agent.name,
                                                      src:
                                                        _vm.domaine +
                                                        "/public/media/user/small/" +
                                                        agent.id +
                                                        "_avatar.jpg",
                                                      size: "35px"
                                                    }
                                                  }),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(agent.name) +
                                                      "\n                      " +
                                                      _vm._s(
                                                        _vm.isItMe(agent.id)
                                                          ? "(" +
                                                              _vm.$t("me") +
                                                              ")"
                                                          : ""
                                                      ) +
                                                      "\n                      - "
                                                  ),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass: "grey--text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " (" +
                                                          _vm._s(
                                                            _vm.user.colleagues[
                                                              i
                                                            ].listeMessages
                                                              .length
                                                              ? _vm.user
                                                                  .colleagues[i]
                                                                  .listeMessages
                                                                  .length +
                                                                  " message(s)"
                                                              : "pas de message en attente"
                                                          ) +
                                                          ")"
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-card",
                                                {
                                                  staticClass: "grey lighten-3"
                                                },
                                                [
                                                  _c(
                                                    "v-card-title",
                                                    {},
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "white--text",
                                                          attrs: {
                                                            loading:
                                                              _vm.loadingMessages,
                                                            disabled:
                                                              _vm.loadingMessages,
                                                            color: "primary"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.getMessagesAttente(
                                                                [agent.id]
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          !_vm.dataMessageSelected &&
                                                          !_vm.$vuetify
                                                            .breakpoint.xsOnly
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "reload"
                                                                    )
                                                                  )
                                                                )
                                                              ])
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                right:
                                                                  !_vm.dataMessageSelected &&
                                                                  !_vm.$vuetify
                                                                    .breakpoint
                                                                    .xsOnly,
                                                                dark: ""
                                                              }
                                                            },
                                                            [_vm._v("cached")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-card-text",
                                                    [
                                                      _c(
                                                        "v-list",
                                                        {
                                                          staticClass:
                                                            "listeTraficVisiteurs grey lighten-3",
                                                          attrs: {
                                                            "two-line": "",
                                                            dense: ""
                                                          }
                                                        },
                                                        _vm._l(
                                                          _vm.user.colleagues[i]
                                                            .listeMessages,
                                                          function(visitor, i) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key: i,
                                                                staticClass:
                                                                  "wz_wrapChips"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    staticClass:
                                                                      "visiteurFiltrer",
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm12: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-tile",
                                                                      {
                                                                        key:
                                                                          visitor.status,
                                                                        class: {
                                                                          "light-blue lighten-4":
                                                                            _vm
                                                                              .messageAttenteSelected
                                                                              .visiteurID ==
                                                                            visitor.visiteurID
                                                                        },
                                                                        attrs: {
                                                                          ripple:
                                                                            ""
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.openMessageVisiteur(
                                                                              agent.id,
                                                                              visitor
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-list-tile-avatar",
                                                                          [
                                                                            visitor.network ==
                                                                              "moon" ||
                                                                            !visitor.network
                                                                              ? _c(
                                                                                  "wz-avatar",
                                                                                  {
                                                                                    staticClass:
                                                                                      "pl-1",
                                                                                    attrs: {
                                                                                      username:
                                                                                        "#" +
                                                                                        visitor.visiteurID,
                                                                                      size:
                                                                                        "38px"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              : visitor.network ==
                                                                                "facebook"
                                                                              ? _c(
                                                                                  "wz-avatar",
                                                                                  {
                                                                                    staticClass:
                                                                                      "pl-1",
                                                                                    attrs: {
                                                                                      src:
                                                                                        visitor.profile_pic,
                                                                                      username:
                                                                                        visitor.visiteurName,
                                                                                      size:
                                                                                        "38px"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              : visitor.network ==
                                                                                "whatsapp"
                                                                              ? _c(
                                                                                  "wz-avatar",
                                                                                  {
                                                                                    staticClass:
                                                                                      "pl-1",
                                                                                    attrs: {
                                                                                      src:
                                                                                        visitor.profile_pic,
                                                                                      username:
                                                                                        visitor.visiteurName,
                                                                                      size:
                                                                                        "38px"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              : !_vm.istypingVisiteur &&
                                                                                visitor.message &&
                                                                                visitor.visiteurID !=
                                                                                  _vm
                                                                                    .messageAttenteSelected
                                                                                    .visiteurID
                                                                              ? _c(
                                                                                  "wz-avatar",
                                                                                  {
                                                                                    attrs: {
                                                                                      username:
                                                                                        "#" +
                                                                                        visitor.visiteurID,
                                                                                      size:
                                                                                        "38px",
                                                                                      lastMessage:
                                                                                        ""
                                                                                    }
                                                                                  }
                                                                                )
                                                                              : _vm.istypingVisiteur
                                                                              ? _c(
                                                                                  "wz-avatar",
                                                                                  {
                                                                                    attrs: {
                                                                                      isTyping:
                                                                                        _vm.istypingVisiteur,
                                                                                      username:
                                                                                        "#" +
                                                                                        visitor.visiteurID,
                                                                                      size:
                                                                                        "38px",
                                                                                      chip:
                                                                                        ""
                                                                                    }
                                                                                  }
                                                                                )
                                                                              : _vm._e()
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "v-list-tile-content",
                                                                          [
                                                                            _c(
                                                                              "v-list-tile-title",
                                                                              [
                                                                                visitor.network ==
                                                                                  "moon" ||
                                                                                !visitor.network
                                                                                  ? _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "wz_nameVisiteur"
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "\n                                        " +
                                                                                            _vm._s(
                                                                                              visitor.visiteurID
                                                                                            ) +
                                                                                            " "
                                                                                        ),
                                                                                        _c(
                                                                                          "span",
                                                                                          [
                                                                                            _vm._v(
                                                                                              "(" +
                                                                                                _vm._s(
                                                                                                  _vm.dateMessageFromNow(
                                                                                                    visitor.timestamp
                                                                                                  )
                                                                                                ) +
                                                                                                ")"
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e(),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                visitor.network ==
                                                                                "email"
                                                                                  ? _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "wz_nameVisiteur"
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "\n                                        " +
                                                                                            _vm._s(
                                                                                              visitor.visiteurID
                                                                                            ) +
                                                                                            " "
                                                                                        ),
                                                                                        _c(
                                                                                          "span",
                                                                                          [
                                                                                            _vm._v(
                                                                                              "(" +
                                                                                                _vm._s(
                                                                                                  _vm.dateMessageFromNow(
                                                                                                    visitor.timestamp
                                                                                                  )
                                                                                                ) +
                                                                                                ")"
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : visitor.network ==
                                                                                    "facebook"
                                                                                  ? _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "wz_nameVisiteur"
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "\n                                        " +
                                                                                            _vm._s(
                                                                                              visitor.visiteurName
                                                                                            ) +
                                                                                            " "
                                                                                        ),
                                                                                        _c(
                                                                                          "span",
                                                                                          [
                                                                                            _vm._v(
                                                                                              "(" +
                                                                                                _vm._s(
                                                                                                  _vm.dateMessageFromNow(
                                                                                                    visitor.timestamp
                                                                                                  )
                                                                                                ) +
                                                                                                ")"
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : visitor.network ==
                                                                                    "whatsapp"
                                                                                  ? _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "wz_nameVisiteur"
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "\n                                        " +
                                                                                            _vm._s(
                                                                                              visitor.visiteurName
                                                                                            ) +
                                                                                            " "
                                                                                        ),
                                                                                        _c(
                                                                                          "span",
                                                                                          [
                                                                                            _vm._v(
                                                                                              "(" +
                                                                                                _vm._s(
                                                                                                  _vm.dateMessageFromNow(
                                                                                                    visitor.timestamp
                                                                                                  )
                                                                                                ) +
                                                                                                ")"
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e()
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            visitor
                                                                              .message
                                                                              .length
                                                                              ? _c(
                                                                                  "v-list-tile-sub-title",
                                                                                  [
                                                                                    visitor
                                                                                      .message
                                                                                      .length
                                                                                      ? _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "wz_alertFiltre",
                                                                                            attrs: {
                                                                                              slot:
                                                                                                "activator"
                                                                                            },
                                                                                            slot:
                                                                                              "activator"
                                                                                          },
                                                                                          [
                                                                                            visitor.network ==
                                                                                              "moon" ||
                                                                                            !visitor.network
                                                                                              ? _c(
                                                                                                  "v-icon",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "secondary--text text--lighten-1",
                                                                                                    attrs: {
                                                                                                      size:
                                                                                                        "20"
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "chat_bubble"
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              : visitor.network ==
                                                                                                "email"
                                                                                              ? _c(
                                                                                                  "v-icon",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "blue-grey--text lighten-2",
                                                                                                    attrs: {
                                                                                                      size:
                                                                                                        "20"
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "email"
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              : visitor.network ==
                                                                                                "facebook"
                                                                                              ? _c(
                                                                                                  "v-icon",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "",
                                                                                                    attrs: {
                                                                                                      size:
                                                                                                        "20",
                                                                                                      color:
                                                                                                        "blue accent-4--text"
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "mdi-facebook-messenger"
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              : visitor.network ==
                                                                                                "whatsapp"
                                                                                              ? _c(
                                                                                                  "v-icon",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "",
                                                                                                    attrs: {
                                                                                                      size:
                                                                                                        "20",
                                                                                                      color:
                                                                                                        "green accent-4--text"
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "mdi-whatsapp"
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              : _vm._e(),
                                                                                            _vm._v(
                                                                                              " "
                                                                                            ),
                                                                                            _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "d-inline"
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    visitor
                                                                                                      .message[0]
                                                                                                  )
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ]
                                                                                )
                                                                              : _vm._e()
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "v-list-tile-action",
                                                                          [
                                                                            _c(
                                                                              "v-btn",
                                                                              {
                                                                                attrs: {
                                                                                  slot:
                                                                                    "activator",
                                                                                  flat:
                                                                                    "",
                                                                                  icon:
                                                                                    "",
                                                                                  color:
                                                                                    "accent"
                                                                                },
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.suppMessage(
                                                                                      {
                                                                                        messageId:
                                                                                          visitor.messageId,
                                                                                        agentId:
                                                                                          visitor.agentId,
                                                                                        visiteurId:
                                                                                          visitor.visiteurID,
                                                                                        message:
                                                                                          visitor.message,
                                                                                        timestamp:
                                                                                          visitor.timestamp
                                                                                      }
                                                                                    )
                                                                                  }
                                                                                },
                                                                                nativeOn: {
                                                                                  mouseover: function(
                                                                                    $event
                                                                                  ) {
                                                                                    _vm.overMenu = true
                                                                                  },
                                                                                  mouseleave: function(
                                                                                    $event
                                                                                  ) {
                                                                                    _vm.overMenu = false
                                                                                  }
                                                                                },
                                                                                slot:
                                                                                  "activator"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    attrs: {
                                                                                      large:
                                                                                        "",
                                                                                      color:
                                                                                        "grey lighten-1"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "close"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "v-divider",
                                                                      {
                                                                        attrs: {
                                                                          inset:
                                                                            ""
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      (_vm.typeClassement == "site" &&
                        !_vm.dataVisiteurComputed.visiteurID &&
                        _vm.$vuetify.breakpoint.xsOnly) ||
                      (_vm.typeClassement == "site" &&
                        !_vm.$vuetify.breakpoint.xsOnly)
                        ? _c(
                            "v-flex",
                            {
                              directives: [{ name: "bar", rawName: "v-bar" }],
                              staticClass: "traficListVisiteurs fill-height vb",
                              class: {
                                sm3: _vm.dataMessageSelected,
                                listeAgentsOverflow: _vm.dataMessageSelected
                              },
                              attrs: { xs12: "" }
                            },
                            [
                              _c(
                                "v-card",
                                { staticClass: "cardTraficVisiteurs" },
                                [
                                  _c(
                                    "v-card-title",
                                    {},
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: { "offset-y": "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        {
                                                          staticClass:
                                                            "white--text",
                                                          attrs: {
                                                            loading:
                                                              _vm.loadingMessages,
                                                            disabled:
                                                              _vm.loadingMessages,
                                                            color: "primary"
                                                          }
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        !_vm.dataMessageSelected &&
                                                        !_vm.$vuetify.breakpoint
                                                          .xsOnly
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f("cap")(
                                                                    _vm.$t(
                                                                      "ranking"
                                                                    )
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              right:
                                                                !_vm.dataMessageSelected &&
                                                                !_vm.$vuetify
                                                                  .breakpoint
                                                                  .xsOnly,
                                                              dark: ""
                                                            }
                                                          },
                                                          [_vm._v("language")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            2884185261
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "v-list",
                                            _vm._l(
                                              _vm.itemsClassement,
                                              function(item, index) {
                                                return _c(
                                                  "v-list-tile",
                                                  {
                                                    key: index,
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.getAllMessagesAttente(
                                                          _vm.listeAgentId,
                                                          item.type
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile-title",
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              left:
                                                                !_vm.dataMessageSelected &&
                                                                !_vm.$vuetify
                                                                  .breakpoint
                                                                  .xsOnly
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(item.icone)
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        !_vm.dataMessageSelected &&
                                                        !_vm.$vuetify.breakpoint
                                                          .xsOnly
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.title
                                                                )
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c("v-subheader", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$tc(
                                              "sites",
                                              _vm.listeSite.length,
                                              { count: _vm.listeSite.length }
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-expansion-panel",
                                        { attrs: { focusable: "" } },
                                        _vm._l(_vm.listeSite, function(
                                          site,
                                          i
                                        ) {
                                          return _c(
                                            "v-expansion-panel-content",
                                            { key: i },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "listeAgentsManagement",
                                                  attrs: { slot: "header" },
                                                  slot: "header"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(site.url) +
                                                      " \n                    - "
                                                  ),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass: "grey--text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " (" +
                                                          _vm._s(
                                                            site.numMessage
                                                              ? site.numMessage +
                                                                  " message(s)"
                                                              : "pas de message en attente"
                                                          ) +
                                                          ")"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-card",
                                                {
                                                  staticClass: "grey lighten-3"
                                                },
                                                [
                                                  _c("v-card-title", {}),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-card-text",
                                                    [
                                                      _c(
                                                        "v-list",
                                                        {
                                                          staticClass:
                                                            "listeTraficVisiteurs grey lighten-3",
                                                          attrs: {
                                                            "two-line": "",
                                                            dense: ""
                                                          }
                                                        },
                                                        _vm._l(
                                                          _vm.listeAllMessagesAttente,
                                                          function(message, i) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key: i,
                                                                staticClass:
                                                                  "wz_wrapChips"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    staticClass:
                                                                      "visiteurFiltrer",
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm12: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    message.siteID ==
                                                                      site.id ||
                                                                    message.network ==
                                                                      site.id
                                                                      ? _c(
                                                                          "div",
                                                                          [
                                                                            _c(
                                                                              "v-list-tile",
                                                                              {
                                                                                key:
                                                                                  message.status,
                                                                                class: {
                                                                                  "light-blue lighten-4":
                                                                                    _vm
                                                                                      .messageAttenteSelected
                                                                                      .visiteurID ==
                                                                                    message.visiteurID
                                                                                },
                                                                                attrs: {
                                                                                  ripple:
                                                                                    ""
                                                                                },
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.openMessageVisiteur(
                                                                                      message.agentId,
                                                                                      message
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-list-tile-avatar",
                                                                                  [
                                                                                    message.network ==
                                                                                      "moon" ||
                                                                                    !message.network
                                                                                      ? _c(
                                                                                          "wz-avatar-double",
                                                                                          {
                                                                                            attrs: {
                                                                                              avatars: [
                                                                                                {
                                                                                                  network:
                                                                                                    "moon",
                                                                                                  id:
                                                                                                    message.visiteurID,
                                                                                                  username:
                                                                                                    message.visiteurName,
                                                                                                  isTyping: false,
                                                                                                  chip: false
                                                                                                },
                                                                                                {
                                                                                                  id:
                                                                                                    message.agentId,
                                                                                                  username:
                                                                                                    message.agentName
                                                                                                }
                                                                                              ]
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      : message.network ==
                                                                                        "facebook"
                                                                                      ? _c(
                                                                                          "wz-avatar-double",
                                                                                          {
                                                                                            attrs: {
                                                                                              avatars: [
                                                                                                {
                                                                                                  network:
                                                                                                    "facebook",
                                                                                                  src:
                                                                                                    message.profile_pic,
                                                                                                  id:
                                                                                                    message.visiteurID,
                                                                                                  username:
                                                                                                    message.visiteurName,
                                                                                                  isTyping: false,
                                                                                                  chip: false
                                                                                                },
                                                                                                {
                                                                                                  id:
                                                                                                    message.agentId,
                                                                                                  username:
                                                                                                    message.agentName
                                                                                                }
                                                                                              ]
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      : message.network ==
                                                                                        "whatsapp"
                                                                                      ? _c(
                                                                                          "wz-avatar-double",
                                                                                          {
                                                                                            attrs: {
                                                                                              avatars: [
                                                                                                {
                                                                                                  network:
                                                                                                    "whatsapp",
                                                                                                  src:
                                                                                                    message.profile_pic,
                                                                                                  id:
                                                                                                    message.visiteurID,
                                                                                                  username:
                                                                                                    message.visiteurName,
                                                                                                  isTyping: false,
                                                                                                  chip: false
                                                                                                },
                                                                                                {
                                                                                                  id:
                                                                                                    message.agentId,
                                                                                                  username:
                                                                                                    message.agentName
                                                                                                }
                                                                                              ]
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "v-list-tile-content",
                                                                                  [
                                                                                    _c(
                                                                                      "v-list-tile-title",
                                                                                      [
                                                                                        message.network ==
                                                                                          "moon" ||
                                                                                        !message.network
                                                                                          ? _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "wz_nameVisiteur"
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "\n                                        " +
                                                                                                    _vm._s(
                                                                                                      message.visiteurID
                                                                                                    ) +
                                                                                                    " "
                                                                                                ),
                                                                                                _c(
                                                                                                  "span",
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "(" +
                                                                                                        _vm._s(
                                                                                                          _vm.dateMessageFromNow(
                                                                                                            message.timestamp
                                                                                                          )
                                                                                                        ) +
                                                                                                        ")"
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          : _vm._e(),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        message.network ==
                                                                                        "email"
                                                                                          ? _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "wz_nameVisiteur"
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "\n                                        " +
                                                                                                    _vm._s(
                                                                                                      message.visiteurID
                                                                                                    ) +
                                                                                                    " "
                                                                                                ),
                                                                                                _c(
                                                                                                  "span",
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "(" +
                                                                                                        _vm._s(
                                                                                                          _vm.dateMessageFromNow(
                                                                                                            message.timestamp
                                                                                                          )
                                                                                                        ) +
                                                                                                        ")"
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          : message.network ==
                                                                                            "facebook"
                                                                                          ? _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "wz_nameVisiteur"
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "\n                                        " +
                                                                                                    _vm._s(
                                                                                                      message.visiteurName
                                                                                                    ) +
                                                                                                    " "
                                                                                                ),
                                                                                                _c(
                                                                                                  "span",
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "(" +
                                                                                                        _vm._s(
                                                                                                          _vm.dateMessageFromNow(
                                                                                                            message.timestamp
                                                                                                          )
                                                                                                        ) +
                                                                                                        ")"
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          : message.network ==
                                                                                            "whatsapp"
                                                                                          ? _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "wz_nameVisiteur"
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "\n                                        " +
                                                                                                    _vm._s(
                                                                                                      message.visiteurName
                                                                                                    ) +
                                                                                                    " "
                                                                                                ),
                                                                                                _c(
                                                                                                  "span",
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "(" +
                                                                                                        _vm._s(
                                                                                                          _vm.dateMessageFromNow(
                                                                                                            message.timestamp
                                                                                                          )
                                                                                                        ) +
                                                                                                        ")"
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          : _vm._e()
                                                                                      ]
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    message
                                                                                      .message
                                                                                      .length
                                                                                      ? _c(
                                                                                          "v-list-tile-sub-title",
                                                                                          [
                                                                                            message
                                                                                              .message
                                                                                              .length
                                                                                              ? _c(
                                                                                                  "div",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "wz_alertFiltre",
                                                                                                    attrs: {
                                                                                                      slot:
                                                                                                        "activator"
                                                                                                    },
                                                                                                    slot:
                                                                                                      "activator"
                                                                                                  },
                                                                                                  [
                                                                                                    message.network ==
                                                                                                      "moon" ||
                                                                                                    !message.network
                                                                                                      ? _c(
                                                                                                          "v-icon",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "secondary--text text--lighten-1",
                                                                                                            attrs: {
                                                                                                              size:
                                                                                                                "20"
                                                                                                            }
                                                                                                          },
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              "chat_bubble"
                                                                                                            )
                                                                                                          ]
                                                                                                        )
                                                                                                      : message.network ==
                                                                                                        "email"
                                                                                                      ? _c(
                                                                                                          "v-icon",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "blue-grey--text lighten-2",
                                                                                                            attrs: {
                                                                                                              size:
                                                                                                                "20"
                                                                                                            }
                                                                                                          },
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              "email"
                                                                                                            )
                                                                                                          ]
                                                                                                        )
                                                                                                      : message.network ==
                                                                                                        "facebook"
                                                                                                      ? _c(
                                                                                                          "v-icon",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "",
                                                                                                            attrs: {
                                                                                                              size:
                                                                                                                "20",
                                                                                                              color:
                                                                                                                "blue accent-4--text"
                                                                                                            }
                                                                                                          },
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              "mdi-facebook-messenger"
                                                                                                            )
                                                                                                          ]
                                                                                                        )
                                                                                                      : message.network ==
                                                                                                        "whatsapp"
                                                                                                      ? _c(
                                                                                                          "v-icon",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "",
                                                                                                            attrs: {
                                                                                                              size:
                                                                                                                "20",
                                                                                                              color:
                                                                                                                "green accent-4--text"
                                                                                                            }
                                                                                                          },
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              "mdi-whatsapp"
                                                                                                            )
                                                                                                          ]
                                                                                                        )
                                                                                                      : _vm._e(),
                                                                                                    _vm._v(
                                                                                                      " "
                                                                                                    ),
                                                                                                    _c(
                                                                                                      "div",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "d-inline"
                                                                                                      },
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          _vm._s(
                                                                                                            message
                                                                                                              .message[0]
                                                                                                          )
                                                                                                        )
                                                                                                      ]
                                                                                                    )
                                                                                                  ],
                                                                                                  1
                                                                                                )
                                                                                              : _vm._e()
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "v-list-tile-action",
                                                                                  [
                                                                                    _c(
                                                                                      "v-btn",
                                                                                      {
                                                                                        attrs: {
                                                                                          slot:
                                                                                            "activator",
                                                                                          flat:
                                                                                            "",
                                                                                          icon:
                                                                                            "",
                                                                                          color:
                                                                                            "accent"
                                                                                        },
                                                                                        on: {
                                                                                          click: function(
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.suppMessage(
                                                                                              {
                                                                                                messageId:
                                                                                                  message.messageId,
                                                                                                agentId:
                                                                                                  message.agentId,
                                                                                                visiteurId:
                                                                                                  message.visiteurID,
                                                                                                message:
                                                                                                  message.message,
                                                                                                timestamp:
                                                                                                  message.timestamp
                                                                                              }
                                                                                            )
                                                                                          }
                                                                                        },
                                                                                        nativeOn: {
                                                                                          mouseover: function(
                                                                                            $event
                                                                                          ) {
                                                                                            _vm.overMenu = true
                                                                                          },
                                                                                          mouseleave: function(
                                                                                            $event
                                                                                          ) {
                                                                                            _vm.overMenu = false
                                                                                          }
                                                                                        },
                                                                                        slot:
                                                                                          "activator"
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "v-icon",
                                                                                          {
                                                                                            attrs: {
                                                                                              large:
                                                                                                "",
                                                                                              color:
                                                                                                "grey lighten-1"
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              "close"
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ],
                                                                              1
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "v-divider",
                                                                              {
                                                                                attrs: {
                                                                                  inset:
                                                                                    ""
                                                                                }
                                                                              }
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : ((_vm.typeClassement == "old" ||
                            _vm.typeClassement == "new") &&
                            !_vm.dataVisiteurComputed.visiteurID &&
                            _vm.$vuetify.breakpoint.xsOnly) ||
                          ((_vm.typeClassement == "old" ||
                            _vm.typeClassement == "new") &&
                            !_vm.$vuetify.breakpoint.xsOnly)
                        ? _c(
                            "v-flex",
                            {
                              directives: [{ name: "bar", rawName: "v-bar" }],
                              staticClass: "traficListVisiteurs fill-height vb",
                              class: {
                                sm3: _vm.dataMessageSelected,
                                listeAgentsOverflow: _vm.dataMessageSelected
                              },
                              attrs: { xs12: "" }
                            },
                            [
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-card-title",
                                    {},
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: { "offset-y": "" },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    _vm._g(
                                                      {
                                                        staticClass:
                                                          "white--text",
                                                        attrs: {
                                                          loading:
                                                            _vm.loadingMessages,
                                                          disabled:
                                                            _vm.loadingMessages,
                                                          color: "primary"
                                                        }
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      !_vm.dataMessageSelected &&
                                                      !_vm.$vuetify.breakpoint
                                                        .xsOnly
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "ranking"
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.typeClassement ==
                                                      "new"
                                                        ? _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                right:
                                                                  !_vm.dataMessageSelected &&
                                                                  !_vm.$vuetify
                                                                    .breakpoint
                                                                    .xsOnly,
                                                                dark: ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "flip_to_front"
                                                              )
                                                            ]
                                                          )
                                                        : _vm.typeClassement ==
                                                          "old"
                                                        ? _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                right:
                                                                  !_vm.dataMessageSelected &&
                                                                  !_vm.$vuetify
                                                                    .breakpoint
                                                                    .xsOnly,
                                                                dark: ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "flip_to_back"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ]
                                              }
                                            }
                                          ])
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "v-list",
                                            _vm._l(
                                              _vm.itemsClassement,
                                              function(item, index) {
                                                return _c(
                                                  "v-list-tile",
                                                  {
                                                    key: index,
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.getAllMessagesAttente(
                                                          _vm.listeAgentId,
                                                          item.type
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile-title",
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              left:
                                                                !_vm.dataMessageSelected &&
                                                                !_vm.$vuetify
                                                                  .breakpoint
                                                                  .xsOnly
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(item.icone)
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        !_vm.dataMessageSelected &&
                                                        !_vm.$vuetify.breakpoint
                                                          .xsOnly
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.title
                                                                )
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "white--text",
                                          attrs: {
                                            loading: _vm.loadingMessages,
                                            disabled: _vm.loadingMessages,
                                            color: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.getMessagesAttente(
                                                _vm.listeAgentId
                                              )
                                            }
                                          }
                                        },
                                        [
                                          !_vm.dataMessageSelected &&
                                          !_vm.$vuetify.breakpoint.xsOnly
                                            ? _c("span", [
                                                _vm._v(_vm._s(_vm.$t("reload")))
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                right:
                                                  !_vm.dataMessageSelected &&
                                                  !_vm.$vuetify.breakpoint
                                                    .xsOnly,
                                                dark: ""
                                              }
                                            },
                                            [_vm._v("cached")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c("i", { staticClass: "grey--text" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.listeAllMessagesAttente.length
                                                ? "Il y a actuellement " +
                                                    _vm.listeAllMessagesAttente
                                                      .length +
                                                    " message(s) en attente d'une réponse"
                                                : "Pas de message en attente"
                                            )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list",
                                        {
                                          staticClass: "listeTraficVisiteurs",
                                          attrs: { "two-line": "", dense: "" }
                                        },
                                        _vm._l(
                                          _vm.listeAllMessagesAttente,
                                          function(message, i) {
                                            return _c(
                                              "div",
                                              {
                                                key: i,
                                                staticClass: "wz_wrapChips"
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  {
                                                    staticClass:
                                                      "visiteurFiltrer",
                                                    attrs: {
                                                      xs12: "",
                                                      sm12: ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile",
                                                      {
                                                        key: message.status,
                                                        class: {
                                                          "light-blue lighten-4":
                                                            _vm
                                                              .messageAttenteSelected
                                                              .visiteurID ==
                                                            message.visiteurID
                                                        },
                                                        attrs: { ripple: "" },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.openMessageVisiteur(
                                                              message.agentId,
                                                              message
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-tile-avatar",
                                                          [
                                                            message.network ==
                                                              "moon" ||
                                                            !message.network
                                                              ? _c(
                                                                  "wz-avatar-double",
                                                                  {
                                                                    attrs: {
                                                                      avatars: [
                                                                        {
                                                                          network:
                                                                            "moon",
                                                                          id:
                                                                            message.visiteurID,
                                                                          username:
                                                                            message.visiteurName,
                                                                          isTyping: false,
                                                                          chip: false
                                                                        },
                                                                        {
                                                                          id:
                                                                            message.agentId,
                                                                          username:
                                                                            message.agentName
                                                                        }
                                                                      ]
                                                                    }
                                                                  }
                                                                )
                                                              : message.network ==
                                                                "facebook"
                                                              ? _c(
                                                                  "wz-avatar-double",
                                                                  {
                                                                    attrs: {
                                                                      avatars: [
                                                                        {
                                                                          network:
                                                                            "facebook",
                                                                          src:
                                                                            message.profile_pic,
                                                                          id:
                                                                            message.visiteurID,
                                                                          username:
                                                                            message.visiteurName,
                                                                          isTyping: false,
                                                                          chip: false
                                                                        },
                                                                        {
                                                                          id:
                                                                            message.agentId,
                                                                          username:
                                                                            message.agentName
                                                                        }
                                                                      ]
                                                                    }
                                                                  }
                                                                )
                                                              : message.network ==
                                                                "whatsapp"
                                                              ? _c(
                                                                  "wz-avatar-double",
                                                                  {
                                                                    attrs: {
                                                                      avatars: [
                                                                        {
                                                                          network:
                                                                            "whatsapp",
                                                                          src:
                                                                            message.profile_pic,
                                                                          id:
                                                                            message.visiteurID,
                                                                          username:
                                                                            message.visiteurName,
                                                                          isTyping: false,
                                                                          chip: false
                                                                        },
                                                                        {
                                                                          id:
                                                                            message.agentId,
                                                                          username:
                                                                            message.agentName
                                                                        }
                                                                      ]
                                                                    }
                                                                  }
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile-content",
                                                          [
                                                            _c(
                                                              "v-list-tile-title",
                                                              [
                                                                message.network ==
                                                                  "moon" ||
                                                                !message.network
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "wz_nameVisiteur"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                " +
                                                                            _vm._s(
                                                                              message.visiteurID
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "(" +
                                                                                _vm._s(
                                                                                  _vm.dateMessageFromNow(
                                                                                    message.timestamp
                                                                                  )
                                                                                ) +
                                                                                ")"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                message.network ==
                                                                "email"
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "wz_nameVisiteur"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                " +
                                                                            _vm._s(
                                                                              message.visiteurID
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "(" +
                                                                                _vm._s(
                                                                                  _vm.dateMessageFromNow(
                                                                                    message.timestamp
                                                                                  )
                                                                                ) +
                                                                                ")"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : message.network ==
                                                                    "facebook"
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "wz_nameVisiteur"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                " +
                                                                            _vm._s(
                                                                              message.visiteurName
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "(" +
                                                                                _vm._s(
                                                                                  _vm.dateMessageFromNow(
                                                                                    message.timestamp
                                                                                  )
                                                                                ) +
                                                                                ")"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : message.network ==
                                                                    "whatsapp"
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "wz_nameVisiteur"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                " +
                                                                            _vm._s(
                                                                              message.visiteurName
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "(" +
                                                                                _vm._s(
                                                                                  _vm.dateMessageFromNow(
                                                                                    message.timestamp
                                                                                  )
                                                                                ) +
                                                                                ")"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            message.message
                                                              .length
                                                              ? _c(
                                                                  "v-list-tile-sub-title",
                                                                  [
                                                                    message
                                                                      .message
                                                                      .length
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "wz_alertFiltre",
                                                                            attrs: {
                                                                              slot:
                                                                                "activator"
                                                                            },
                                                                            slot:
                                                                              "activator"
                                                                          },
                                                                          [
                                                                            message.network ==
                                                                              "moon" ||
                                                                            !message.network
                                                                              ? _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    staticClass:
                                                                                      "secondary--text text--lighten-1",
                                                                                    attrs: {
                                                                                      size:
                                                                                        "20"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "chat_bubble"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : message.network ==
                                                                                "email"
                                                                              ? _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    staticClass:
                                                                                      "blue-grey--text lighten-2",
                                                                                    attrs: {
                                                                                      size:
                                                                                        "20"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "email"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : message.network ==
                                                                                "facebook"
                                                                              ? _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    staticClass:
                                                                                      "",
                                                                                    attrs: {
                                                                                      size:
                                                                                        "20",
                                                                                      color:
                                                                                        "blue accent-4--text"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-facebook-messenger"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : message.network ==
                                                                                "whatsapp"
                                                                              ? _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    staticClass:
                                                                                      "",
                                                                                    attrs: {
                                                                                      size:
                                                                                        "20",
                                                                                      color:
                                                                                        "green accent-4--text"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "mdi-whatsapp"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "d-inline"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    message
                                                                                      .message[0]
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile-action",
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  slot:
                                                                    "activator",
                                                                  flat: "",
                                                                  icon: "",
                                                                  color:
                                                                    "accent"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.suppMessage(
                                                                      {
                                                                        messageId:
                                                                          message.messageId,
                                                                        agentId:
                                                                          message.agentId,
                                                                        visiteurId:
                                                                          message.visiteurID,
                                                                        message:
                                                                          message.message,
                                                                        timestamp:
                                                                          message.timestamp
                                                                      }
                                                                    )
                                                                  }
                                                                },
                                                                nativeOn: {
                                                                  mouseover: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.overMenu = true
                                                                  },
                                                                  mouseleave: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.overMenu = false
                                                                  }
                                                                },
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      large: "",
                                                                      color:
                                                                        "grey lighten-1"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "close"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-divider", {
                                                      attrs: { inset: "" }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dataMessageSelected
                        ? _c(
                            "v-flex",
                            {
                              staticClass: "traficInfosVisiteur fill-height",
                              attrs: { xs12: "", sm9: "" }
                            },
                            [
                              _vm.loadingHistoChat
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "wz_loadingChat text-xs-center"
                                    },
                                    [
                                      _c("v-progress-circular", {
                                        staticClass: "primary--text",
                                        attrs: {
                                          size: 70,
                                          width: 1,
                                          indeterminate: ""
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _c("wz-view-chat", {
                                    attrs: {
                                      datasViewPupitre:
                                        _vm.dataVisiteurComputed,
                                      placesPupitre: 1
                                    },
                                    on: {
                                      activeCobrowsing: function($event) {
                                        return _vm.openCobrowsing(0)
                                      },
                                      stopCobrowsing: function($event) {
                                        return _vm.closeCobrowsing(0)
                                      },
                                      MAJHistoChat: _vm.MAJHistoChat
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.focusView({
                                          view: 1,
                                          visiteurID:
                                            _vm.messageAttenteSelected
                                              .visiteurID
                                        })
                                      }
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.dialogSupMessage,
            callback: function($$v) {
              _vm.dialogSupMessage = $$v
            },
            expression: "dialogSupMessage"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text subheading" },
                [
                  _vm._v(
                    _vm._s(_vm._f("cap")(_vm.$t("supMessageAttenteTitre")))
                  )
                ]
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("cap")(_vm.$t("supMessageAttenteContent"))) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "blue--text darken-1",
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.dialogSupMessage = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("no")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text darken-1",
                      attrs: {
                        loading: _vm.loadingSupp,
                        disabled: _vm.loadingSupp,
                        color: "accent"
                      },
                      on: {
                        click: function($event) {
                          return _vm.confirmSuppMessage()
                        }
                      }
                    },
                    [_vm._v("\n          " + _vm._s(_vm.$t("yes")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.dialogOpenChatPush,
            callback: function($$v) {
              _vm.dialogOpenChatPush = $$v
            },
            expression: "dialogOpenChatPush"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text subheading" },
                [_vm._v(_vm._s(_vm._f("cap")(_vm.$t("openChat"))))]
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("cap")(_vm.$t("dialogRepVisiteur"))) +
                    " (" +
                    _vm._s(_vm.directChat) +
                    ")\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "blue--text darken-1",
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.dialogOpenChatPush = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("no")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text darken-1",
                      attrs: {
                        loading: _vm.loadingSupp,
                        disabled: _vm.loadingSupp,
                        color: "accent"
                      },
                      on: {
                        click: function($event) {
                          return _vm.checkIdVisiteurURL(_vm.directChat)
                        }
                      }
                    },
                    [_vm._v("\n          " + _vm._s(_vm.$t("yes")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8898b04e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8898b04e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/trafic/Attente.vue
// module id = null
// module chunks = 